import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Popover } from '@mui/material';

import ProfileListItems from 'components/ProfileListItems';
import UserInfoIcon from 'components/icons/UserInfoIcon';

import { MANAGE_ACCOUNT_ROUTE } from 'utilities/routes';

import styles from './styles.module.scss';

const UserProfile = ({ onLogout, onItemClick }) => {
    const [anchorElement, setAnchorElement] = useState(null);
    const open = Boolean(anchorElement);
    const id = open ? 'simple-popover' : '';

    const history = useHistory();

    const anchorOrigin = {
        vertical: 'bottom',
        horizontal: 'right'
    };

    const transformOrigin = {
        vertical: 'top',
        horizontal: 'right'
    };

    const handleClick = event => {
        setAnchorElement(val => (val ? null : event.currentTarget));
    };

    const handleClose = () => {
        setAnchorElement(null);
    };

    const manageAccount = () => {
        handleClose();
        onItemClick();
        history.push(MANAGE_ACCOUNT_ROUTE);
    };

    const handleLogout = () => {
        handleClose();
        onLogout();
    };

    return (
        <>
            <div className={styles.desktop}>
                <UserInfoIcon handleClick={handleClick} icon={UserInfoIcon} />
                <Popover
                    anchorEl={anchorElement}
                    anchorOrigin={anchorOrigin}
                    className={styles.popover}
                    elevation={3}
                    id={id}
                    onClose={handleClose}
                    open={open}
                    transformOrigin={transformOrigin}
                >
                    <div className={styles.userProfileOption}>
                        <ProfileListItems
                            handleLogout={handleLogout}
                            manageAccount={manageAccount}
                        />
                    </div>
                </Popover>
            </div>

            <ProfileListItems
                className={styles.mobile}
                handleLogout={handleLogout}
                manageAccount={manageAccount}
            />
        </>
    );
};

export default UserProfile;
